import apiClient from './apiClient';

export const getGames = () => apiClient.get('/game');
export const createGame = (data) => apiClient.post('/game', data);
export const updateGame = (id, data) => apiClient.put(`/game/${id}`, data);
export const deleteGame = (id) => apiClient.delete(`/game/${id}`);

export const getGamePlays = (params) => apiClient.get('/game-play', { params });
export const updateGamePlay = (id, data) => apiClient.put(`/game-play/${id}`, data);
// 获取赔率列表
export const getGameOddsList = (params) => apiClient.get(`/odds/${params.gameId}`, { params });
// 更新赔率
export const updateGameOdds = (id, data) => apiClient.put(`/odds/${id}`, data);
// 获取开奖结果
export const getGameResult = (params) => apiClient.get(`/result/${params.gameId}`, { params });


